/*
 * Copyright (c) 2008-2025 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */

import { API_HOST, EXPORTS_HOST } from "./urls"

export default {
  /**
   *  Infos about currently logged in user
   */
  ME: () => API_HOST + "/me",
  ME_PASSWORD: () => API_HOST + "/me/password",
  ME_TENANT: () => API_HOST + "/me/tenant",

  /**
   * meetings
   */
  MEETINGS: (id = null) => {
    if (id === null) return API_HOST + "/meetings"
    else return API_HOST + "/meetings/" + id
  },

  CLONE_MEETING: (id) => {
    return API_HOST + "/meetings/" + id + "/clones"
  },

  RESET_MEETING: (id) => {
    return API_HOST + "/meetings/" + id + "/resets"
  },

  START_MEETING: (id) => {
    return API_HOST + "/meetings/" + id + "/activations"
  },

  STOP_MEETING: (id) => {
    return API_HOST + "/meetings/" + id + "/deactivations"
  },

  WAITING_ROOM: (id) => {
    return API_HOST + "/meetings/" + id + "/waiting-room"
  },

  WAITING_ROOM_ACTIVATIONS: (id) => {
    return API_HOST + "/meetings/" + id + "/waiting-room/activations"
  },

  WAITING_ROOM_DEACTIVATIONS: (id) => {
    return API_HOST + "/meetings/" + id + "/waiting-room/deactivations"
  },

  LET_USERS_IN: (id) => {
    return API_HOST + "/meetings/" + id + "/admissions"
  },

  AUTO_JOIN_MEETING: () => API_HOST + "/meetings/autojoin",

  MEETINGS_UPLOAD: () => API_HOST + "/meetings/import",

  MEETING_OWNER: (id) => API_HOST + `/meetings/${id}/owner`,

  VOTING_IMAGE_UPLOAD: () => API_HOST + "/voting-images",

  VOTING_IMAGE_DELETE: (fileName) => API_HOST + "/voting-images/" + fileName,

  INTERACTION_IMAGE_UPLOAD: () => API_HOST + "/interaction-images",

  INTERACTION_IMAGE_DELETE: (fileName) => API_HOST + "/interaction-images/" + fileName,

  CMS_AGENDA_UPLOAD: () => API_HOST + "/cms/agenda",

  CMS_LOCKSCREEN_UPLOAD: () => API_HOST + "/cms/lockscreen-images",

  CMS_LOCKSCREEN_DELETE: (fileName) => API_HOST + "/cms/lockscreen-images/" + fileName,

  CMS_SPEAKER_EXCEL_UPLOAD: () => API_HOST + "/cms/speaker-infos",

  CMS_SPEAKER_IMAGES_UPLOAD: () => API_HOST + "/cms/speaker-images",

  CMS_SPEAKER_IMAGES_DELETE: (fileName) => API_HOST + "/cms/speaker-images/" + fileName,

  CMS_TRAVEL_INFO_UPLOAD: () => API_HOST + "/cms/travel-infos",

  CMS_GENERIC_IMAGES_UPLOAD: () => API_HOST + "/cms/generic-images",

  CMS_GENERIC_IMAGES_DELETE: (fileName) => API_HOST + "/cms/generic-images/" + fileName,

  CMS_PUBLISH: () => API_HOST + "/cms/publish",

  CMS_FEATURES: () => API_HOST + "/cms/features",

  MEETING_PROPERTY_DELETE: (meetingId, propertyName) => API_HOST + `/meetings/${meetingId}/properties/${propertyName}`,

  MEETING_PROPERTIES_PATCH: (meetingId) => API_HOST + `/meetings/${meetingId}/properties`,

  /**
   * meeting sharing
   */

  MEETING_COLLABORATORS: (ids) => {
    return `${API_HOST}/role-assignments/objects?ids=${ids}&objectType=Meeting`
  },

  MEETING_COLLABORATOR_ROLES: (meetingId) => {
    return `${API_HOST}/meetings/${meetingId}/user-roles`
  },

  /**
   * meeting exports
   */
  MEETINGS_DOWNLOAD: (id) => API_HOST + "/meetings/" + id + "/export",
  HTML_EXPORT: (id) => EXPORTS_HOST + "/meetings/result.do?id=" + id + "&toolnames=true",
  EXCEL_EXPORT: (id) => EXPORTS_HOST + "/meetings/result.do?id=" + id + "&format=excel&toolnames=true",
  EXCEL_EXPORT_PERSONALIZED: (id) =>
    EXPORTS_HOST + "/meetings/result.do?id=" + id + "&format=excel&toolnames=true&personalized=true&userDetails=false",
  MEETINGS_INTERACTIONS_EXPORT: () => EXPORTS_HOST + "/meetings/result.do",
  MEETINGS_FEEDBACK_EXPORT: () => EXPORTS_HOST + "/meetings/question-results.do",
  MEETINGS_FORMS_EXPORT: () => EXPORTS_HOST + "/meetings/form-results.do",
  MEETING_PARTICIPANT_PROPERTIES: (id) => API_HOST + "/meetings/" + id + "/participant-properties",
  MEETING_AUTH_SETTINGS: (id) => API_HOST + "/meetings/" + id + "/auth-settings",
  MEETING_STREAMING_SERVER: (id) => API_HOST + "/meetings/" + id + "/streaming",
  TIMETRACKING_MIN_DATETIME: () => `${EXPORTS_HOST}/timetracking-min-datetime.do`,
  TIMETRACKING_EXPORT: (id, includeBreakouts, start, end, props) =>
    `${EXPORTS_HOST}/meetings/timetracking.do?meetingId=${id}&includeBreakouts=${includeBreakouts}&start=${start}&end=${end}&props=${props}`,

  /**
   * lan event
   */
  LAN_EVENT: () => API_HOST + "/lan-event",

  /**
   * server license
   */
  SERVER_LICENSE: () => API_HOST + "/server-license",

  /**
   * administration
   */
  USER_EXCEL_UPLOAD: () => API_HOST + "/participant-users",
  USER_EXCEL_DOWNLOAD: () => API_HOST + "/participant-users/download",

  /**
   * Participant management
   */
  MEETING_PARTICIPANTS_UPLOAD: (meetingId) => API_HOST + `/meetings/${meetingId}/participants/import`,
  MEETING_PARTICIPANTS_DOWNLOAD: (meetingId, format) =>
    API_HOST + `/meetings/${meetingId}/participants/export?format=${format}`,
  MEETING_PARTICIPANTS: (meetingId) => API_HOST + `/meetings/${meetingId}/participants/`,
  MEETING_PARTICIPANT: (meetingId, participantId) => API_HOST + `/meetings/${meetingId}/participants/${participantId}`,
  MEETING_PARTICIPANT_PROPERTY: (meetingId, participantId, property) =>
    API_HOST + `/meetings/${meetingId}/participants/${participantId}/properties/${property}`,
  MEETING_PARTICIPANT_ACCREDITATION: (meetingId, participantId) =>
    API_HOST + `/meetings/${meetingId}/participants/${participantId}/accreditation`,
  MEETING_PARTICIPANT_DELEGATORS: (meetingId, participantId) =>
    API_HOST + `/meetings/${meetingId}/participants/${participantId}/direct-or-indirect-delegators`,
  GLOBAL_PARTICIPANT_PROPERTIES: (meetingId) => API_HOST + `/meetings/${meetingId}/participant-properties`,

  MEETING_PARTICIPANTS_BULK: (meetingId) => API_HOST + `/meetings/${meetingId}/participants/bulk`,

  USER_RELOADS: () => API_HOST + "/users/reloads",
  USER_AUTO_SELECTION: () => API_HOST + "/users/auto-selection",
  USER_AUTO_SELECTION_RESET: () => API_HOST + "/users/auto-selection/resets",
  USER_AUTO_SELECTION_ACTIVATION: () => API_HOST + "/users/auto-selection/activations",
  USER_AUTO_SELECTION_DEACTIVATION: () => API_HOST + "/users/auto-selection/deactivations",
  USER_DELETE_USER: (id) => API_HOST + `/participant-users/${id}`,
  USER_DELETE_ALL_USERS: () => API_HOST + "/participant-users",

  ROLES: () => API_HOST + "/roles",
  USER_ROLES: (userId, roleId) => API_HOST + "/users/" + userId + "/roles" + (roleId !== undefined ? "/" + roleId : ""),
  USERS: (userId) => API_HOST + "/users" + (userId ? "/" + userId : ""),
  USER_SESSIONS: (userId) => API_HOST + "/users/" + userId + "/sessions",
  USER_PROPERTIES: (userId) => API_HOST + "/users/" + userId + "/properties",
  USER_PASSWORD: (userId) => API_HOST + "/users/" + userId + "/password",

  PUBLIC_USERS_NAME: (username, tenantId) =>
    API_HOST + `/users-public?username=${username}` + (tenantId !== undefined ? `&tenantId=${tenantId}` : ""),
  PUBLIC_USERS_ID: (userIds) => API_HOST + `/users-public?ids=${userIds}`,

  GENERATE_TOKEN_LINK: (userId) => API_HOST + "/users/" + userId + "/password-reset-links",
  SEND_RESET_TOKEN_LINK: (userId) => API_HOST + "/users/" + userId + "/password-reset-mails",

  /**
   * Licensing managment
   */

  LICENSES_PACKAGES: (licenseId) => `${API_HOST}/license-packages` + (licenseId !== undefined ? `/${licenseId}` : ""),
  LICENSES_FEATURES: () => `${API_HOST}/license-features`,

  /**
   * system configuration
   */
  SYSTEM_CONFIGURATION: () => API_HOST + "/cc-configuration",

  /**
   * authentication/ authorization
   */
  ACCESS_TOKEN: () => API_HOST + "/me/token",

  SESSIONS: () => API_HOST + "/me/sessions",

  PERMISSIONS: () => API_HOST + "/me/permissions",

  MEETING_PERMISSIONS: (meetingIds) => API_HOST + "/me/meeting-permissions?meetingIds=" + meetingIds,

  /**
   * tenants
   */

  TENANTS: (tenantId = null) => {
    if (tenantId === null) return API_HOST + "/tenants"
    else return API_HOST + "/tenants/" + tenantId
  },

  TENANTS_BY_IDS: (tenantIds) => API_HOST + "/tenants?tenantIds=" + tenantIds,

  TENANTS_SEARCH: (searchString) => API_HOST + `/tenants?search=%25${searchString}%25`,

  TENANT_LICENSE_ASSIGNMENT: (tenantId, assignmentId) =>
    `${API_HOST}/tenants/${tenantId}/license-assignments` + (assignmentId ? `/${assignmentId}` : ""),

  /**
   * License package, -assignment and -feature set currently in effect for specified tenants
   */
  TENANT_EFFECTIVE_LICENSES: (tenantIds) => `${API_HOST}/effective-licenses?tenantIds=${tenantIds}`,

  TENANT_MEETING_COUNTS: (tenantId) => API_HOST + `/tenants/${tenantId}/meeting-counts`,

  /**
   * Maintenance message
   */
  MAINTENANCE_MESSAGE: () => API_HOST + "/maintenance-message",

  // Server statistics
  SERVER_STATISTICS: (metrics) => API_HOST + `/statistics` + (metrics !== undefined ? `?metrics=${metrics}` : ""),

  OBJECT_CACHE: () => API_HOST + "/cache/objectCache",
  USERS_CACHE: () => API_HOST + "/cache/usersCache",

  INHERITABLE_CONFIG_VALUE: (targetType, targetId, key) =>
    API_HOST + `/inheritable-config/${targetType}/${targetId}/${key}`,
}
